import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="loans"
export default class extends Controller {
  connect() {
    console.log("Loans controller connected");
  }


  async calculateFee() {
    try {
      const amount = document.getElementById("loan_amount").value;
      const interestRate = document.getElementById("loan_interest_rate").value;
      const months = document.getElementById("loan_period_number").value;
      if (!amount || !interestRate || interestRate == 0.0 || !months) {
        console.error("All fields are required");
        return;
      }
      const data = {
        amount: parseFloat(amount),
        interest_rate: parseFloat(interestRate),
        months: parseInt(months, 10)
      }
      const response = await fetch("/fees/calculate_fee?" + new URLSearchParams(data))
      const jsonString = await response.text()
      const jsonObject = JSON.parse(jsonString)
      document.getElementById("loan_fee").value = jsonObject.formated_number;
      document.getElementById("loan_end_date").value = new Date(jsonObject.end_date).toISOString().split('T')[0]; 
      document.getElementById("loan_months_number").value = jsonObject.months_number;
      document.getElementById("loan_fee_account").value = jsonObject.fee_account;
      const input = document.querySelector('input[type="submit"]');
      input.disabled = false;
      input.classList.remove("bg-gray-400", "cursor-not-allowed");
      input.classList.add("bg-[#BF1724]");
    } catch (error) {
      console.error("Error fetching loans:", error);
    }
  }

  blockButton() {
    console.log("Blocking submit button");
    const input = document.querySelector('input[type="submit"]');

    input.disabled = true;
    input.classList.add("bg-gray-400", "cursor-not-allowed");
  }
}
